var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlightDeparts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24.0000977px",
    viewBox: "0 0 24 24.0000977",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C3C9B56D-1469-43E5-BCF9-26DC627C1379") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KLM",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Summary",
    transform: "translate(-796.000120, -6518.000000)",
    fill: "#00A1DE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KLM/Summary/XS-576",
    transform: "translate(656.000000, 5755.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/flights-S",
    transform: "translate(140.000120, 763.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,24.0000977 L11.2941636,24.0000977 L11.2941636,21.9050304 L0,21.9050304 L0,24.0000977 Z M16.9313631,10.4471014 L14.9859434,19.9341988 L13.752056,19.7647864 L12.9120526,12.183579 L12.6974635,11.3788699 C10.5543959,11.8447541 8.60897624,12.2400498 7.63061931,12.4094623 C5.50731655,12.7906403 5.13037384,11.9294603 5.11907967,11.9012249 L5.1176679,11.9012249 L2.82354091,7.76473751 L4.30166458,6.77649819 L7.60661921,9.99533482 C8.63156456,9.64239221 10.215571,9.10591944 11.9393427,8.55532896 L11.7247536,7.7506198 L8.66262351,0.762356046 L9.64380398,0 L16.0772419,7.25650014 C17.202423,6.90355753 18.2428978,6.60708573 19.0730189,6.38120246 C22.3864441,5.49178707 23.641508,5.73178805 23.9464505,6.84708671 L23.9478622,6.84708671 C24.2499811,7.97650307 23.2800948,8.80944764 19.9610225,9.69886303 C19.1309014,9.9247463 18.0777207,10.178865 16.9313631,10.4471014 Z",
    id: "Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightDeparts);
export default __webpack_public_path__ + "static/media/flight-departs.9506345c5c4e80f19e1b5fe56eca0f34.svg";
export { ForwardRef as ReactComponent };